var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_vm._v("\n\tBLANK CONTENT CONTAINER\t\n")])}
var staticRenderFns = []

export { render, staticRenderFns }